import React from "react";
import { Table } from "react-bootstrap";
import { Search } from "lucide-react";

const AllocatedLotsPanel = ({
  selected,
  filteredSelected,
  searchSelected,
  setSearchSelected,
  checkedSelected,
  handleSelectAllSelected,
  handleSelectSelectedRow,
  handleInlineSelectedEdit,
  getCheckedRowBg,
  themeColors,

}) => {
  const {
    borderTheme,
    headingCol,

    textTheme,
    iscolour,
    iscolourDark,
    isdark,
    tableBg,
    tableText,
    tableBorder,
    tableHeaderBg
  } = themeColors;


  console.log(selected);
  console.log(filteredSelected);

  const totalIssueTaka = (selected || []).reduce(
    (sum, lot) => sum + (Number(lot?.issueTaka) || 0),
    0
  );

  const totalIssueMeter = (selected || []).reduce(
    (sum, lot) => sum + (Number(lot?.issueMeter) || 0),
    0
  );


  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          border: `1px solid ${borderTheme}`,
          borderRadius: "14px",
          padding: "14px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: isdark === "light"
            ? `linear-gradient(160deg, ${iscolour?.Colour1 || "#fff"} 0%, ${iscolour?.Colour4 || "#fef3e8"} 100%)`
            : `linear-gradient(160deg, ${iscolourDark?.Colour9 || "#2d1f0f"} 0%, ${iscolourDark?.Colour8 || "#6b4423"} 100%)`,
          boxShadow: isdark === "light" ? `0 6px 24px ${iscolour?.Colour6 || "#e6a571"}30` : `0 6px 24px rgba(0,0,0,0.3)`,
          transition: "all 0.3s ease"
        }}
        className="hover-card-glowing"
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "800", fontSize: "15px", letterSpacing: "0.3px", color: headingCol }}>Allocated Roll Lots</span>
            <span
              style={{
                borderRadius: "20px",
                padding: "3px 10px",
                fontSize: "12px",
                fontWeight: "700",
                background: isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637",
                color: isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour1 || "#fcefd9",
                border: `1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour6 || "#8b5a2b"}`
              }}
            >
              {selected.length} Lots
            </span>
          </div>
        </div>

        <div style={{ position: "relative", marginBottom: "16px" }}>
          <Search
            size={16}
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540",
              pointerEvents: "none"
            }}
          />
          <input
            type="text"
            placeholder="Search Allocated Lots..."
            value={searchSelected}
            onChange={(e) => setSearchSelected(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px 10px 38px",
              borderRadius: "10px",
              border: `1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"}`,
              background: isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour8 || "#6b4423",
              color: textTheme,
              fontSize: "13px",
              outline: "none",
              transition: "all 0.2s ease"
            }}
            className="workspace-search-input"
          />
        </div>

        {/* Table Container */}
        <div
          style={{
            maxHeight: "480px",
            overflowY: "auto",
            border: `1px solid ${borderTheme}`,
            borderRadius: "10px"
          }}
          className="theme-scroll custom-workspace-scroll"
        >
          <Table hover responsive className="custom-workspace-table" style={{ margin: 0, fontSize: "13px", background: tableBg, color: tableText, borderColor: tableBorder }}>
            <thead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2
              }}
            >
              <tr>
                <th
                  className="text-center"
                  style={{
                    width: "45px",
                    background: "transparent"
                  }}
                >
                  Select
                </th>
                <th style={{ background: "transparent" }}>Lot No</th>
                <th style={{ background: "transparent" }}>Inw.Date</th>
                <th style={{ background: "transparent" }}>InwSr.No.</th>
                <th style={{ background: "transparent" }}>Group Name</th>
                <th style={{ background: "transparent" }}>Quality Name</th>
                <th className="text-end" style={{ background: "transparent", width: "90px" }}>Issue Taka</th>
                <th className="text-end" style={{ background: "transparent", width: "100px" }}>Issue Meter</th>
                <th className="text-end" style={{ background: "transparent", width: "100px" }}>Operater</th>
                <th className="text-end" style={{ background: "transparent", width: "100px" }}>Shift</th>
                <th className="text-end" style={{ background: "transparent", width: "100px" }}>Intime</th>
                <th className="text-end" style={{ background: "transparent", width: "100px" }}>Outtime</th>
                <th className="text-end" style={{ background: "transparent", width: "100px" }}>Avgweight</th>
                <th className="text-end" style={{ background: "transparent", width: "100px" }}>Weight</th>
              </tr>
            </thead>
            <tbody>
              {selected?.length === 0 ? (
                <tr style={{ background: tableBg }}>
                  <td
                    colSpan={14}
                    className="text-center py-4 text-secondary"
                    style={{ background: "transparent" }}
                  >
                    No lots allocated to this record yet. Select from available list.
                  </td>
                </tr>
              ) : (
                selected?.map((lot) => {

                  const rowId = String(lot?.InwCode);

                  const isChecked = !!checkedSelected[rowId];
                  const rowBg = getCheckedRowBg(isChecked, true);

                  const totalIssueTaka = (selected || []).reduce(
                    (sum, lot) => sum + (Number(lot?.issueTaka) || 0),
                    0
                  );

                  // ✅ Total Issue Meter
                  const totalIssueMeter = (selected || []).reduce(
                    (sum, lot) => sum + (Number(lot?.issueMeter) || 0),
                    0
                  );

                  return (
                    <tr
                      key={rowId}
                      style={{
                        background: rowBg,
                        color: tableText,
                        cursor: "pointer"
                      }}
                      onClick={() =>
                        handleSelectSelectedRow(rowId, !isChecked)
                      }
                    >
                      {/* 1. Checkbox */}
                      <td

                        className="text-center"
                        onClick={(e) => e.stopPropagation()}
                        style={{ background: "transparent" }}

                      >
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={(e) =>
                            handleSelectSelectedRow(
                              rowId,
                              e.target.checked
                            )
                          }
                          className="custom-checkbox"
                        />
                      </td>



                      {/* 2. Lot No */}
                      <td
                        className="fw-semibold"
                        style={{ background: "transparent" }}
                      >
                        {lot.LotNo ?? "-"}
                      </td>

                      {/* 3. Inw.Date */}
                      <td style={{ background: "transparent" }}>
                        {lot.inwDate ?? "-"}
                      </td>

                      {/* 4. InwSr.No. */}
                      <td style={{ background: "transparent" }}>
                        {lot.inwSrNo ?? "-"}
                      </td>

                      {/* 5. Group Name */}
                      <td style={{ background: "transparent" }}>
                        {lot.groupName ?? "-"}
                      </td>

                      {/* 6. Quality Name */}
                      <td style={{ background: "transparent" }}>
                        {lot.quality ?? "-"}
                      </td>

                      {/* 7. Issue Taka */}
                      <td
                        className="text-end"
                        onClick={(e) => e.stopPropagation()}
                        style={{ background: "transparent" }}
                      >
                        <input
                          type="number"
                          value={lot.issueTaka ?? ""}
                          onChange={(e) =>
                            handleInlineSelectedEdit(
                              lot.id,
                              "issueTaka",
                              e.target.value
                            )
                          }
                          className="modal-quantity-input"
                          style={{
                            width: "70px",
                            margin: "0 auto",
                            padding: "4px 8px",
                            fontSize: "12px"
                          }}
                        />
                      </td>

                      {/* 8. Issue Meter */}
                      <td
                        className="text-end"
                        onClick={(e) => e.stopPropagation()}
                        style={{ background: "transparent" }}
                      >
                        <input
                          type="text"
                          inputMode="decimal"
                          step="0.01"
                          value={
                            lot.issueMeter !== null &&
                              lot.issueMeter !== undefined &&
                              lot.issueMeter !== ""
                              ? Number(lot.issueMeter).toFixed(2)
                              : ""
                          }
                          onChange={(e) =>
                            handleInlineSelectedEdit(
                              lot.id,
                              "issueMeter",
                              e.target.value
                            )
                          }
                          className="modal-quantity-input"
                          style={{
                            width: "80px",
                            margin: "0 auto",
                            padding: "4px 8px",
                            fontSize: "12px"
                          }}
                        />
                      </td>

                      {/* 9. Operater */}
                      <td
                        className="text-end"
                        style={{ background: "transparent" }}
                      >
                        {lot._Operator ?? "-"}
                      </td>

                      {/* 10. Shift */}
                      <td
                        className="text-end"
                        style={{ background: "transparent" }}
                      >
                        {lot._Shift ?? "-"}
                      </td>

                      {/* 11. Intime */}
                      <td
                        className="text-end"
                        style={{ background: "transparent" }}
                      >
                        {lot._InTime ?? "-"}
                      </td>

                      {/* 12. Outtime */}
                      <td
                        className="text-end"
                        style={{ background: "transparent" }}
                      >
                        {lot._OutTime ?? "-"}
                      </td>

                      {/* 13. Avgweight */}
                      <td
                        className="text-end"
                        style={{ background: "transparent" }}
                      >
                        {lot._AvgWeight ?? "-"}
                      </td>

                      {/* 14. Weight */}
                      <td
                        className="text-end"
                        style={{ background: "transparent" }}
                      >
                        {lot._Weight ?? "-"}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>

            <tfoot>
              <tr
                style={{
                  background: tableHeaderBg,
                  color: tableText,
                  fontWeight: "800",
                  position: "sticky",
                  bottom: 0,
                  zIndex: 2,
                }}
              >
                {/* Select + Lot No + Date + InwSr.No + Group + Quality */}
                <td
                  colSpan={6}
                  className="text-end"
                  style={{
                    background: tableHeaderBg,
                    color: tableText,
                    padding: "10px",
                    borderTop: `2px solid ${borderTheme}`,
                  }}
                >
                  TOTAL
                </td>

                {/* Total Issue Taka */}
                <td
                  className="text-end"
                  style={{
                    background: tableHeaderBg,
                    color: tableText,
                    borderTop: `2px solid ${borderTheme}`,
                  }}
                >
                  {totalIssueTaka}
                </td>

                {/* Total Issue Meter */}
                <td
                  className="text-end"
                  style={{
                    background: tableHeaderBg,
                    color: tableText,
                    borderTop: `2px solid ${borderTheme}`,
                  }}
                >
                  {totalIssueMeter.toFixed(2)}
                </td>

                {/* Remaining columns */}
                <td
                  colSpan={6}
                  style={{
                    background: tableHeaderBg,
                    borderTop: `2px solid ${borderTheme}`,
                  }}
                />
              </tr>
            </tfoot>

          </Table>
        </div>
      </div>
    </div>
  );
};

export default AllocatedLotsPanel;
